export default __webpack_public_path__ + "static/media/france.85cf6f25.svg";